export const META_SAFE_ROUTE_PATHS = [
  "/",
  "/about/",
  "/ai-employee-vs-chatbot-vs-automation/",
  "/ai-employees/",
  "/apply/",
  "/console/",
  "/contact/",
  "/cookie-policy/",
  "/cookies/",
  "/data/",
  "/data-processing/",
  "/demo/",
  "/industries/",
  "/industries/clinics/",
  "/industries/hair-derm-clinics/",
  "/industries/real-estate/",
  "/industries/salons/",
  "/pricing/",
  "/privacy/",
  "/refund/",
  "/refund-cancellation/",
  "/services/",
  "/terms/",
  "/use-cases/",
  "/use-cases/lead-follow-up/",
  "/use-cases/marketing-ai-employee/",
  "/use-cases/operations-ai-employee/",
  "/use-cases/sales-ai-employee/",
  "/ai-training/",
  "/ai-training/business/",
  "/ai-training/institutions/",
  "/ai-training/education/",
  "/workshops/",
] as const;

export const META_SAFE_ROUTE_ALIASES: ReadonlyMap<string, string> = new Map(
  META_SAFE_ROUTE_PATHS.flatMap((path) => {
    if (path === "/") return [["/", "/"]];
    return [
      [path, path],
      [path.slice(0, -1), path],
    ];
  })
);

const SAFE_PATH_SET = new Set<string>(META_SAFE_ROUTE_PATHS);

export function canonicalMetaPath(pathname: unknown): string | undefined {
  if (typeof pathname !== "string" || !pathname.startsWith("/")) {
    return undefined;
  }

  let decoded: string;

  try {
    decoded = decodeURIComponent(pathname);
  } catch {
    return undefined;
  }

  const canonical = META_SAFE_ROUTE_ALIASES.get(decoded) ?? decoded;

  return SAFE_PATH_SET.has(canonical) ? canonical : undefined;
}

export function isConfirmedSuccessfulLeadEvent(eventName: string): boolean {
  return eventName === "lead_submit_succeeded";
}

export function mapMetaEvent(eventName: string): {
  name: string;
  standard: boolean;
} {
  if (eventName === "page_view") {
    return { name: "PageView", standard: true };
  }

  if (isConfirmedSuccessfulLeadEvent(eventName)) {
    return { name: "Lead", standard: true };
  }

  if (eventName === "whatsapp_opened") {
    return { name: "Contact", standard: true };
  }

  if (eventName === "cta_clicked") {
    return { name: "CTAClick", standard: false };
  }

  return { name: eventName, standard: false };
}
